import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["borderColor", "color", "legacy", "borderWidth", "borderStyle", "padding", "verticalAlign"];
import { IconHolder } from '../IconHolder/IconHolder';
import { IconCircleContext } from './IconCircleProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const IconCircle = _ref => {
  let {
      borderColor,
      color,
      legacy = false,
      borderWidth = '100',
      borderStyle = 'solid',
      padding,
      verticalAlign = '-0.1em' // Aligns the icon with text by default
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(IconCircleContext.Provider, {
    value: {
      isLegacy: legacy
    },
    children: /*#__PURE__*/_jsx(IconHolder, Object.assign({}, rest, {
      borderColor: borderColor || color,
      borderRadius: "full",
      padding: legacy ? '0' : padding,
      color: color,
      borderWidth: borderWidth,
      borderStyle: borderStyle,
      verticalAlign: verticalAlign
    }))
  });
};